import axios from "axios";
import { authConstants, logout } from "../actions/auth/index";
import { displayErrorToast, displaySuccessToast } from "../actions/overflowNotification";
import { refreshTokenWithQueue } from "./refreshTokenWithQueue";

export function callWithRetry(
  auth, request, dispatch, callback, displayError = false, displaySuccess = false, codes = ["401"]
) {
  let tokenToUse = auth?.loginAuth?.securityToken;
  return new Promise(function(resolve, reject) {    
    if (tokenToUse) {
      auth.securityToken = tokenToUse;
      auth.accessToken = tokenToUse;
      request.headers["Authorization"] = "Bearer " + tokenToUse;
      axios(request)
        .then((result) => {
          returnSuccess(
            callback, result, displaySuccess, dispatch
          );
          resolve(result);
        })
        .catch((error) => {          
          let errorCodeAlt = undefined;

          if (error.response && error.response.data) {
            errorCodeAlt = error.response.data.code ? error.response.data.code : error.response.status ? error.response.status.toString() : null;
          }

          if (codes.includes(error.code) || codes.includes(errorCodeAlt)) {
            if (!auth.isRefreshingToken && localStorage.getItem("isRefreshingTokenDBX") !== "true") {
              refreshTokenWithQueue(auth, dispatch)
                .then((res) => {
                  auth.securityToken = auth.loginAuth.loginMethod === "tsid" ? res.accessToken : res;
                  auth.accessToken = auth.loginAuth.loginMethod === "tsid" ? res.accessToken : res;
                  request.headers["Authorization"] = "Bearer " + (auth.loginAuth.loginMethod === "tsid" ? res.accessToken : res);
                  axios(request)
                    .then((result) => {
                      returnSuccess(
                        callback, result, displaySuccess, dispatch
                      );
                      resolve(result);
                    })
                    .catch((err) => {
                      returnError(
                        callback, err, displayError, dispatch
                      );
                      reject(err);
                    });
                })
                .catch((e) => {
                  if (codes.includes(e.code)) {
                    logout(auth.id, auth.securityToken)(dispatch);
                  } else {
                    returnError(
                      callback, e, displayError, dispatch
                    );
                    
                    reject(e);
                  }
                });
            } else {
              reject({
                code: "701",
                message: "Token is already refreshing"
              });
            }
          } else if (error.code === "403.1") {
            dispatch({
              type: authConstants.LOGIN_ERROR,
              error,
              errorInfo: error
            });
          } else {
            returnError(
              callback, error, displayError, dispatch
            );
            reject(error);
          }
        });
    } else {      
      reject({
        error: "703",
        message: "Error during token checking"
      });
    }
  });
}

function returnError(
  callback, error, displayError, dispatch
) {
  
  if (callback) {
    callback(error);
  }

  if (displayError) {
    displayErrorToast(error.message)(dispatch);
  }
}

function returnSuccess(
  callback, result, displaySuccess, dispatch
) {
  if (callback) {
    callback(null, result);
  }

  if (displaySuccess) {
    displaySuccessToast("Operazione correttamente presa in carico")(dispatch);
  }
}
